import React from 'react'
import { Header, View, Row, Column, Intro, LinksList } from 'components/Layout'
import { Button } from 'components/Button'
// import { PostsListContainer, ProjectsListContainer } from '../../containers'
// import Telescope from '../../assets/intros/telescope.svg'
import girlPinning from '../../assets/intros/girl-pinning.png'
import { Image } from 'components/Image'

import Media from 'react-media'

const Explore = () => {
	const examplesAndDocs = [
		{
			title: 'Build your own chat widget with Customer SDK',
			desc:
				'With Customer SDK you can create your very own chat widget and manage multiple chats via chat.io as a customer using JavaScript.',
			link: 'https://www.chat.io/docs/customer-sdk/'
		},
		{
			title: 'Create an Agent App Extension',
			desc:
				'Embed a web application inside our Agent App. It can be a simple knowledge base or advanced CRM integration module.',
			link: 'https://www.chat.io/docs/agent-app-extension'
		},
		{
			title: 'Start a conversation using Customer API',
			desc:
				'Join the conversation as a customer or build your own backend chat client.',
			link: 'https://www.chat.io/docs/customer-api/'
		},
		{
			title: 'Use Agent API to interact with customers',
			desc:
				'Interact with customers by joining the messaging protocol as an agent.',
			link: 'https://www.chat.io/docs/agent-api/'
		}
		// {
		// 	title: 'Android Chat Widget',
		// 	desc:
		// 		'Make yourself available for your mobile users and embed the chat.io mobile chat window in your Android application.',
		// 	link: 'https://www.chat.io/docs/android-widget/'
		// }
	]

	return (
		<View>
			<Media query={{ minWidth: 480 }}>
				<Header>
					<Row center>
						<Column width={3}>
							<Intro
								header={'Explore'}
								body={
									"We've got some inspirations waiting for you!"
								}
							/>
						</Column>
					</Row>
				</Header>
			</Media>
			<Row topMargin center>
				{/* <Column width={5}>
					<PostsListContainer />
				</Column>
				<Column width={4}>
					<ProjectsListContainer />
				</Column> */}
				<Column width={5}>
					<LinksList
						header={'Examples & Docs'}
						info={
							<a
								href={process.env.REACT_APP_DEV_DOCS_URL}
								target="_blank"
								rel="noopener"
							>
								<Button>See all</Button>
							</a>
						}
						links={examplesAndDocs}
					/>
				</Column>
				<Column width={5} center>
					<Image width={150} height={280} src={girlPinning} />
				</Column>
			</Row>
		</View>
	)
}
export default Explore



// WEBPACK FOOTER //
// ./src/views/Explore/Explore.js